import axios from "axios";

export const mercadoPagoHttpClient = axios.create({
  baseURL: "https://reservation.prod.llt.kairoxlab.xyz/api/v1/",
});

